<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1024 1024"
    class="svg-icon icon-to-fullscreen"
    width="20"
    height="20"
  >
    <path
      fill="currentColor"
      d="M409.376 553.376L224 738.752V608a32 32 0 0 0-64 0v192.544c0 3.488 0.48 6.848 1.024 10.176a31.456 31.456 0 0 0 8.352 27.904c2.336 2.336 5.152 3.808 7.904 5.248 11.648 12.48 28.096 20.384 46.464 20.384h192.512a32 32 0 1 0 0-64l-163.488 0.224 201.856-201.856a31.968 31.968 0 1 0-45.248-45.248M800.512 160H608a32 32 0 0 0 0 64l146.944-0.192-201.568 201.568a31.968 31.968 0 1 0 45.248 45.248l201.632-201.632v147.264a32 32 0 1 0 64 0V223.744A63.84 63.84 0 0 0 800.512 160"
    ></path>
  </svg>
</template>

<script>
/**
 * 评论框最大化用箭头图标
 */
export default {
  name: 'SvgToFullscreen',
};
</script>

<style></style>
